import { render, staticRenderFns } from "./UpdateStepForm.vue?vue&type=template&id=6890248a&"
import script from "./UpdateStepForm.vue?vue&type=script&lang=js&"
export * from "./UpdateStepForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports